module.exports = __webpack_public_path__ + "static/kvm_5.b3a0620d.jpg";